export enum OrderProductPreviewType {
  THUMBNAIL = 'preview_thumbnail',
  DEFAULT = 'preview_default',
  FLAT = 'preview_flat',
}
